<template>
  <div class="main_box" v-loading.fullscreen="loading">
    <div class="full_layout">
      <!-- <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/messages' }">Messages</el-breadcrumb-item>
      <el-breadcrumb-item>Message details</el-breadcrumb-item>
    </el-breadcrumb> -->
      <div class="details">
        <h1>{{list.Title}}</h1>
        <ul class="detail_ul">
          <!-- <li>{{ $t('colon.nickName') }}{{list.RealName}}</li> -->
          <li>{{ $t('colon.time') }}{{list.CreateDate|setTime}}</li>
        </ul>
        <div v-html="details"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo,getTime } from "@/api/public";
import qs from 'qs'
export default {
  name: "",
  data() {
    return {
      userInfo: '',
      mid: '',
      list: '',
      details: 'Message details',
      loading:false
    };
  },
  filters: {
    //设置时间
    setTime(val) {
      return getTime(val, -8,'','cn')
    }
  },
  created() {
    this.mid = this.$route.params.id
    this.userInfo = getInfo()
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.notification'));
    this.NotificationDetail()
  },
  mounted() {},
  methods: {
    // 获取信息详情
    NotificationDetail() {
      let that = this;
      that.loading=true;
      let data={id:that.mid,memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, operator_id: that.userInfo.MappingUserId}
      this.$get(this.$interface.NotificationDetail,data).then(res=>{
        if(res.result!=0){
          that.list=res.data
          that.details=res.data.Body
          if(res.data.ContentDesc){
            that.details=res.data.ContentDesc
          }
          that.loading=false;
        }
      })
    }
  },
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.breadcrumb {
  height: 48px;
  line-height: 48px;
}

.details {
  padding: 20px;
}

.details>h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.detail_ul {
  margin-bottom: 30px;
}

.detail_ul li {
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/pages/messages/detail.vue